<template>
  <div style="min-height: 100vh">
    <ProductHeader />
    <v-container grid-list-xs xs="12" lg="6" sm="5" md="4">
      <component :is="recent.component" />
      <div v-for="(value, key) in Object.keys(prod_for())" :key="key">
        <h3 class="nunito mt-5 mb-3 font-weight-bold leaf--text red--text">
          {{ stripTagNumbering(value) }}
        </h3>

        <div class="products_list__main__grid__container">
          <div class="products_list__grid__container">
            <div
              class="products_list__grid_content"
              v-for="(v, i) in prod_for()[value]"
              :key="i"
              @click="!isOutOfStock(v) && selectProduct(v)"
              :style="{ cursor: isOutOfStock(v) ? 'not-allowed' : 'pointer' }"
            >
              <div
                class="products_list__grid_content_selected_cart"
                v-if="renderQuantityFromCart(v) > 0"
              >
                <div class="products_list__grid_content_selected_cart_text">
                  {{ renderQuantityFromCart(v) }}
                </div>
              </div>
              <img
                v-if="v.media_urls.length > 0"
                :src="image(v.media_urls[0])"
              />
              <img v-else :src="emptyImage()" />
              <div class="products_list__grid_content_bottom">
                <div class="products_list__grid_content_bottom__name">
                  <span style="font-weight: 600">
                    {{ v.code }}
                  </span>
                  {{ v.name }}
                </div>
                <div>
                  <div
                    class="lato font-weight-bold font-italic red--text"
                    v-if="isOutOfStock(v)"
                  >
                    Sold Out
                  </div>
                  <div v-else class="flex">
                    <div class="" v-if="v.price_type == 0">
                      <div
                        v-if="v.variants.length > 1"
                        class="products_list__grid_content_bottom__price"
                      >
                        RM {{ currency(getMinVariantPrice(v.variants)) }} - RM
                        {{ currency(getMaxVariantPrice(v.variants)) }}
                      </div>
                      <div
                        v-else
                        class="products_list__grid_content_bottom__price"
                      >
                        RM {{ currency(v.unit_price) }}
                      </div>
                    </div>
                    <div
                      class="products_list__grid_content_bottom__price"
                      v-else-if="v.price_type == 1"
                    >
                      RM {{ currency(v.unit_price) }}
                    </div>
                    <div
                      class="products_list__grid_content_bottom__price"
                      v-else
                    >
                      RM {{ currency(v.unit_price) }}
                    </div>
                    <div
                      class="products_list__grid_content_bottom__price ml-2 grey--text line-through"
                      v-if="v.before_discount"
                    >
                      RM {{ currency(v.before_discount) }}
                    </div>
                  </div>
                </div>
                <div class="products_list__grid_content__add_cart_container">
                  <v-btn
                    class="products_list__grid_content__add_cart"
                    v-if="!isOutOfStock(v)"
                    >Add</v-btn
                  >
                  <div
                    v-else
                    class="products_list__grid_content__add_cart_placeholder"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProductHeader from "../../../common/ProductHeader.vue";
export default {
  name: "grid",
  components: {
    ProductHeader,
  },
  data() {
    return {
      first: null,
      recent: { component: () => import("../Recent") },
    };
  },

  computed: {
    ...mapGetters({
      product: "getFilteredProducts",
      cart: "getCart",
      franchise: "getFranchise",
      selectedTag: "getSelectedTags",
      isTagCurrentlyActive: "isTagCurrentlyActive",
    }),

    currency() {
      return require("currency.js");
    },
    cekKarakter(val) {
      let text = val;
      let result = text.substring(0, 10);
      let hasil = result.length;

      return hasil;
    },

    tag_list() {
      var tags = {};
      const isTagActive = this.isTagCurrentlyActive;
      // Only show tags where hidden_tag=0, hidden_product=0, AND tag is currently active (per-tag time)
      if (this.product && Array.isArray(this.product) && isTagActive) {
        this.product.forEach((prod) => {
          if (prod.tags && Array.isArray(prod.tags)) {
            prod.tags.forEach((tag) => {
              const isHiddenTag =
                tag.hidden_tag === true || tag.hidden_tag === 1;
              const isHiddenProduct =
                tag.hidden_product === true ||
                tag.hidden_product === 1 ||
                tag.hidden_products === true ||
                tag.hidden_products === 1;
              if (!isHiddenTag && !isHiddenProduct && isTagActive(tag)) {
                return (tags[tag.id] = tag);
              }
            });
          }
        });
      }
      return Object.values(tags).sort(function (a, b) {
        // Respect order_column first, then by name
        const aOrder = a.order_column != null ? a.order_column : 0;
        const bOrder = b.order_column != null ? b.order_column : 0;
        if (aOrder !== bOrder) return aOrder - bOrder;
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
  },

  watch: {
    // Watch for changes in product data to ensure tag_list updates
    product: {
      handler(newProducts) {
        if (newProducts && Array.isArray(newProducts)) {
          // Force reactivity update for tag_list
          this.$forceUpdate();
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    stripTagNumbering(tagName) {
      // Strip numbering pattern like "01. ", "1. ", "01.", "1." from the start
      return tagName.replace(/^\d+\.\s*/, "");
    },
    isOutOfStock(product) {
      return product.total_left == 0 || product.out_of_stock;
    },
    renderQuantityFromCart(product) {
      const quantity = this.cart
        .filter((item) => item.id === product.id)
        .map((d) => d.quantity)
        .reduce((a, b) => Number(a) + Number(b), 0);
      return quantity;
    },
    getMinVariantPrice(variants) {
      return Math.min(...variants.map((variant) => variant.price));
    },
    getMaxVariantPrice(variants) {
      return Math.max(...variants.map((variant) => variant.price));
    },
    image(i) {
      if (i.s512) {
        return i.s512;
      } else
        return (
          "https://s3-ap-southeast-1.amazonaws.com/assets.getorders/" +
          i.original
        );
    },
    emptyImage() {
      return (
        "https://s3-ap-southeast-1.amazonaws.com/assets.getorders/" +
        this.franchise.logo
      );
    },

    selectProduct(i) {
      this.$store.commit("setScrollPosition", window.pageYOffset);
      this.$store.dispatch("updateSP", i);
      this.track(i.name);
      const { outlet_id, table_id } = this.$route.params;
      const { session } = this.$route.params;
      if (table_id && outlet_id) {
        // static link
        this.$router.push({
          name: "ProductsDetail",
          params: {
            child: this.$route.params.child,
            outlet_id,
            table_id,
            page: "product",
          },
        });
      } else if (session) {
        // SESSION QR
        this.$router.push({
          name: "SessionProductsDetail",
          params: { session },
        });
      } else {
        // shop link
        this.$router.push({
          name: "ShoplinkProductsDetail",
          params: { child: this.$route.params.child, page: "product" },
        });
      }
    },

    track(val) {
      this.$gtag.event("view_product", {
        event_category: "view_product",
        event_label: "view_product",
        value: val,
      });
    },

    prod_for() {
      var list = this.product;
      // Prioritaskan produk berdasarkan media
      var priority_list = [
        ...list.filter((p) => p.media_urls.length > 0),
        ...list.filter((p) => p.media_urls.length == 0),
      ];

      // Urutkan produk berdasarkan atribut numerik jika ada
      priority_list = priority_list.sort(function (a, b) {
        return (a.priority || 0) - (b.priority || 0);
      });

      // Then sort by product code/name according to requirements
      priority_list = priority_list.sort(function (a, b) {
        const aHasCode = a.code && a.code.trim() !== "";
        const bHasCode = b.code && b.code.trim() !== "";

        // If both have codes, sort by code (numeric-aware)
        if (aHasCode && bHasCode) {
          return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        }

        // If only a has code, a comes first
        if (aHasCode && !bHasCode) {
          return -1;
        }

        // If only b has code, b comes first
        if (!aHasCode && bHasCode) {
          return 1;
        }

        // If neither has code, sort by name
        const aName = a.name || "";
        const bName = b.name || "";
        return aName.localeCompare(bName, undefined, { sensitivity: "base" });
      });

      // Group products by ALL their visible tags; only add to tag if tag is currently active (per-tag time)
      const groupedByTag = {};
      const isTagActive = this.isTagCurrentlyActive;

      for (const obj of priority_list) {
        if (obj.tags && obj.tags.length > 0 && isTagActive) {
          obj.tags.forEach((tag) => {
            const isHiddenTag = tag.hidden_tag === true || tag.hidden_tag === 1;
            const isHiddenProduct =
              tag.hidden_product === true ||
              tag.hidden_product === 1 ||
              tag.hidden_products === true ||
              tag.hidden_products === 1;
            if (!isHiddenTag && !isHiddenProduct && isTagActive(tag)) {
              const tagName = tag.name;
              const isNumberTag = !isNaN(tagName);
              const tagPriority = isNumberTag ? parseFloat(tagName) : tagName;
              if (!groupedByTag[tagPriority]) groupedByTag[tagPriority] = [];
              if (!groupedByTag[tagPriority].includes(obj)) {
                groupedByTag[tagPriority].push(obj);
              }
            }
          });
        }
      }

      // Urutkan kelompok tag berdasarkan jenisnya (angka atau nama)
      const sortedGroupedByTag = Object.keys(groupedByTag)
        .sort((a, b) => {
          const aIsNumber = !isNaN(a);
          const bIsNumber = !isNaN(b);

          if (aIsNumber && bIsNumber) {
            return parseFloat(a) - parseFloat(b); // Urutkan angka
          } else if (aIsNumber) {
            return -1; // Angka sebelum nama
          } else if (bIsNumber) {
            return 1; // Nama setelah angka
          } else {
            return a.localeCompare(b, undefined, { sensitivity: "base" });
          }
        })
        .reduce((acc, key) => {
          acc[key] = groupedByTag[key];
          return acc;
        }, {});

      return sortedGroupedByTag;
    },
  },

  mounted() {
    // console.log(this.product)
    //  console.log("grid");
    // this.scroll(this.tag_list[0].name);
    if (this.tag_list.length > 0) {
      this.first = this.tag_list[0].name;
    }
  },
};
</script>
<style lang="scss">
.products_list__main__grid__container {
  justify-content: center;
  align-items: center;
  width: 100%;
  display: flex;

  .products_list__grid__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    @media (min-width: 350px) and (max-width: 600px) {
      justify-content: space-between;
    }

    .products_list__grid_content {
      @media (min-width: 350px) and (max-width: 600px) {
        margin-top: 40px;
      }

      position: relative;

      .products_list__grid_content_selected_cart {
        position: absolute;
        right: 5px;
        top: 5px;

        .products_list__grid_content_selected_cart_text {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: white;
          color: #f85757;
          justify-content: center;
          font-weight: bolder;
          align-items: center;
          display: flex;
        }
      }

      width: 30%;
      border-radius: 15px;
      margin: 10px;
      // box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      @media (min-width: 350px) and (max-width: 600px) {
        width: 45%;
        margin: 5px;
      }

      @media (min-width: 200px) and (max-width: 300px) {
        width: 100%;
        margin: 5px;
      }

      img {
        width: 100%;
        border-top-right-radius: 15px;
        border-top-left-radius: 15px;
        height: 170px;
        object-fit: cover;

        @media (min-width: 350px) and (max-width: 600px) {
          height: 110px;
        }
      }

      .products_list__grid_content_bottom {
        width: 100%;
        padding-left: 10px;
        padding-right: 8px;
        padding-bottom: 8px;

        .products_list__grid_content_bottom__name {
          font-size: 12px;
          font-weight: 400;
          margin-top: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 3px;
        }

        .products_list__grid_content_bottom__price {
          font-size: 12px;
          font-weight: 400;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 10px;
        }

        .products_list__grid_content__add_cart_container {
          width: 100%;

          .products_list__grid_content__add_cart {
            color: white;
            background-color: #f85757;
            width: 100%;
            border-radius: 10px;
            text-transform: none;
          }

          .products_list__grid_content__add_cart_placeholder {
            visibility: hidden;
            height: 36px; /* height of v-btn */
          }
        }
      }
    }
  }
}

.elipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.flexcard {
  display: flex;
  flex-direction: column;
}

.v-tabsactive {
  background-color: #ffff !important;
}

.height {
  height: 100%;
}

.red_tab_text {
  color: #f85757 !important;
}

.greener {
  background-color: #8e8e8e !important;
}

.line-through {
  text-decoration: line-through red;
}

.v-slide-group__prev {
  display: none !important;
  visibility: hidden;
}
</style>
